import { cloneDeep } from 'lodash';

// import action types
import { ADD_COMPONENT_DATA, CLEAR_USER_SESSION } from 'constants/redux-events';

/********************************************************/

/**
 * @type {function}
 * @desc A Redux Reducer to manage state of the Redux Store
 * @param {object} [state={}] - Current state of the Redux Store at given state key
 * @param {object} action - Redux **action** object with **event name** and **payload**
 * @example
 * import { addComponentData } from 'store/reducers/addComponentData';
 */
export const addComponentData = ( state = {}, action ) => {
    const { type, payload } = action;

    // clone current state
	const _state = cloneDeep( state );

    switch( type ) {

        // add new component data
        case ADD_COMPONENT_DATA: {
            _state[ payload.componentName ] = payload.componentData;
            return _state;
        }
        
        // clear all component when session is cleard
		case CLEAR_USER_SESSION: {
            return {};
        }
        
        // else return current state
        default: {
            return state;
        }
    }
};
